import {
  SHOW_CREATE_NEW_BROADCAST,
  SET_BROADCAST_WHATSAPP_LIST,
  SHOW_BROADCAST_CONTACT_LIST,
  SHOW_BROADCAST_CANCEL_DIALOG,
  SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG,
  REMOVE_BROADCAST_FROM_LIST,
  ADD_BROADCAST,
  UPDATE_BROADCAST_STATUS,
  SET_BROADCAST_WHATSAPP_TEMPLATE_MESSAGE,
  SET_BROADCAST_CONTACTS_SELECTED,
} from '@/store/mutation-types';

const mutations = {
  [SHOW_CREATE_NEW_BROADCAST](state, value) {
    state.showCreateNewBroadcast.dialog = value;
  },
  [SET_BROADCAST_WHATSAPP_LIST](state, value) {
    state.broadcastList = value.reverse();
  },
  [SET_BROADCAST_CONTACTS_SELECTED](state, value) {
    const contacts = new Set();
    value.forEach((el) => {
      contacts.add({
        contactName: el.fullname,
        contactIdentifier: el.identifier,
        contactId: el.id,
        contactWhatsAppIdentifier: el.whatsapp_identifier,
        disabled: false,
      });
    });
    state.showCreateNewBroadcast.contactsSelected = Array.from(contacts);
  },
  [SHOW_BROADCAST_CONTACT_LIST](state, value) {
    if (value == null) {
      state.showBroadcastContactList.dialog = false;
      state.showBroadcastContactList.broadcastListId = null;
    } else {
      state.showBroadcastContactList.dialog = true;
      state.showBroadcastContactList.broadcastListId = value;
    }
  },
  [SHOW_BROADCAST_CANCEL_DIALOG](state, value) {
    if (value == null) {
      state.broadcastCancel.dialog = false;
      state.broadcastCancel.broadcastListId = null;
    } else {
      state.broadcastCancel.dialog = true;
      state.broadcastCancel.broadcastListId = value;
    }
  },
  [SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG](state, value) {
    state.broadcastWhatsAppTemplate.dialog = value;
  },
  [REMOVE_BROADCAST_FROM_LIST](state, broadcastListId) {
    const indexBroadcastList = state.broadcastList.findIndex(
      (broadcast) => broadcast.whatsapp_broadcast_list_id == broadcastListId,
    );

    if (indexBroadcastList > -1) {
      state.broadcastList.splice(indexBroadcastList, 1);
    }
  },
  [ADD_BROADCAST](state, broadcastInformation) {
    state.broadcastList.splice(0, 0, broadcastInformation);
  },
  [UPDATE_BROADCAST_STATUS](state, broadcastInformation) {
    const indexBroadcastList = state.broadcastList.findIndex(
      (broadcast) =>
        broadcast.whatsapp_broadcast_list_id ==
        broadcastInformation.broadcastWhatsAppId,
    );

    if (indexBroadcastList > -1) {
      if (broadcastInformation.type == 'default') {
        let broadcast = state.broadcastList[indexBroadcastList];
        broadcast.contacts.forEach((contact) => {
          contact.status = broadcastInformation.status;
        });

        state.broadcastList.splice(indexBroadcastList, 1, broadcast);
      }

      if (broadcastInformation.type == 'update-schedule') {
        let broadcast = state.broadcastList[indexBroadcastList];
        broadcast.contacts.forEach((contact) => {
          if (contact.scheduleId == broadcastInformation.schedule.scheduleId) {
            contact.status = broadcastInformation.schedule.status;
          }
        });

        state.broadcastList.splice(indexBroadcastList, 1, broadcast);
      }

      if (broadcastInformation.type == 'bulk') {
        let broadcast = state.broadcastList[indexBroadcastList];
        broadcast.contacts.forEach((contact) => {
          const contactFound = broadcastInformation.schedules.find(
            (schedule) => schedule.contactId == contact.contactId,
          );

          if (contactFound != undefined) {
            contact.status = contactFound.status;
          }
        });

        state.broadcastList.splice(indexBroadcastList, 1, broadcast);
      }
    }
  },
  [SET_BROADCAST_WHATSAPP_TEMPLATE_MESSAGE](state, message) {
    state.showCreateNewBroadcast.templateMessageSelected = message;
  },
};

export default mutations;
